/**
 * Labstep
 *
 * @module components/EntityUser/Avatar
 * @desc   EntityUser Avatar
 */

import { ProfilePictureImagePopup as ProfilePictureImage } from 'labstep-web/components/Profile/Picture/Image';
import { Flex } from 'labstep-web/core/Flex';
import { Size } from 'labstep-web/core/Initials/types';
import type React from 'react';
import styles from './styles.module.scss';
import type { EntityUserAvatarProps } from './types';

export const EntityUserAvatar: React.FC<EntityUserAvatarProps> = ({
  entityUser,
  showName,
  ...rest
}) => (
  <Flex spacing="gap" vAlignContent="center" shrink={0}>
    <ProfilePictureImage
      size={Size.mini}
      entity={entityUser.user}
      {...rest}
    />
    {entityUser.is_assigned && (
      <div className={styles.dot}>
        <div />
      </div>
    )}
    {showName && <Flex grow>{entityUser.user?.name}</Flex>}
  </Flex>
);
